import LoginUI from "./components/LoginUI";
import React, { useEffect, useState } from "react";
import App from "./App";

const InitApp: React.FC = () => {
  const [loginState, setLoginState] = useState(false);
  useEffect(() => {
    if (loginState) {
      console.log("In LoginState use effect ", loginState);
      setLoginState(true);
    }
  }, [loginState]);

  const loginStateHandler = () => {
    setLoginState(true);
    console.log("In loginState Handler ", loginState);
  };

  return (
    <div className="viewer-container">
      {!loginState ? (
        <LoginUI
          loginState={loginState}
          loginStateHandler={loginStateHandler}
        />
      ) : (
        <App></App>
      )}
    </div>
  );
};

export default InitApp;
